import React, { useState, useEffect } from "react";
import "./Button.css";

const Button = ({
  buttonText,
  onClickAction,
  color,
  disabled,
  type,
  nativeType,
}) => {
  return (
    <button
      className={`button ${disabled ? "button__disabled" : ""} button__${type}`}
      type={nativeType}
      style={{ backgroundColor: color ? color : "#fff" }}
      onClick={onClickAction ? () => onClickAction() : null}
    >
      {buttonText}
    </button>
  );
};
export default Button;
